import React, { useContext, useState, useEffect, useRef } from "react";
import { AppContext } from "./components/States/AppContext";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  BrowserRouter,
} from "react-router-dom";
import { Capacitor } from "@capacitor/core";

// Layouts
import Layout from "./components/Layouts/Layout";
import SettingLayout from "./components/Layouts/SettingLayout";
import ScreenLayout from "./components/Layouts/ScreenLayout";

//styles
import { AppBox, DeviceImage, GlobalStyles } from "./GlobalStyles.styles";
import { AppBg } from "./GlobalStyles.styles";

// Components
import Buttons from "./components/MonitorComponents/Buttons";

// Pages
import MainScreenPages from "./pages/MainScreen/MainScreen1";
import PowerOn from "./pages/Misc/PowerOn";
import SmartKeyBox from "./components/Settings/SmartKeyBox";
import Setting from "./pages/Settings/Settings";
import PopUps from "./pages/PopUps/PopUps";
import LockScreenPages from "./pages/Misc/Lock";
import StandbyScreen from "./pages/Misc/StandbyScreen";
import Blank from "./pages/Misc/Blank";
import Trends from "./pages/Landscape/Trends";
import TrendsSetting from "./pages/Landscape/TrendsSetting";
import ReviewAlarms from "./pages/Landscape/ReviewAlarms";
import LandscapePage from "./pages/Landscape/LandscapePage";
import Disclaimer from "./pages/Misc/Disclaimer";

//Background
import bgTest from "./img/5500NewBg7.7_cropped.png";

function App() {
  const { state, setState } = useContext(AppContext);

  const CurrentPage = MainScreenPages[state.currentPageIndex];
  const CurrentLockScreen = LockScreenPages[state.lockScreenIndex];

  useEffect(() => {
    if (state.annotate === false) {
      const timeoutId = setTimeout(() => {
        setState((prevState) => ({
          ...prevState,
          annotate1Img: false,
          annotate2Img: false,
          relearn: false,
          masterRelearn: false,
          annotateOrRelearn: false,
        }));
      }, 0);

      return () => clearTimeout(timeoutId);
    }
  }, [state.annotate]);

  useEffect(() => {
    if (state.annotate === true) {
      const timeoutId = setTimeout(() => {
        setState((prevState) => ({
          ...prevState,
          annotate1Img: true,
        }));
      }, 0);

      return () => clearTimeout(timeoutId);
    }
  }, [state.annotate]);

  useEffect(() => {
    if (state.masterRelearn === true) {
      const timeoutId = setTimeout(() => {
        setState((prevState) => ({
          ...prevState,

          relearn: false,
        }));
      }, 3600);

      return () => clearTimeout(timeoutId);
    }
  }, [state.masterRelearn]);

  useEffect(() => {
    if (state.blankScreen === true) {
      const timeoutId = setTimeout(() => {
        setState((prevState) => ({
          ...prevState,
          blankScreen: false,
          currentPageIndex: 0,
          reboot: true,
          telemetry: false,
          spoStart: false,
          waveData: state.initValues.initWaveData,
          numericValues: state.initValues.initNumericValues,
        }));
      }, 1500);

      return () => clearTimeout(timeoutId);
    }
  }, [state.blankScreen]);

  useEffect(() => {
    if (state.reboot === true) {
      const timeoutId = setTimeout(() => {
        setState((prevState) => ({
          ...prevState,
          reboot: false,
          telemetry: true,
          piicConnected: true,
          settingAlertAudio: true,
        }));
      }, 6000);

      return () => clearTimeout(timeoutId);
    }
  }, [state.reboot]);

  return (
    <>
      <BrowserRouter>
        <AppBg native={Capacitor.isNativePlatform()}>
          <AppBox>
            <DeviceImage src={bgTest} className="noselect" />

            <div
              className="noselect"
              style={{
                position: "absolute",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
              }}
            ></div>
            <GlobalStyles />
            <Routes>
              <Route path="/" element={<Layout />}>
                {state.disclaimer && <Route index element={<Disclaimer />} />}
                {state.init && <Route index element={<PowerOn />} />}

                <Route
                  index
                  element={
                    state.standBy ? (
                      <StandbyScreen />
                    ) : state.blankScreen ? (
                      <Blank />
                    ) : state.isButtonPressed ? (
                      <CurrentLockScreen />
                    ) : (
                      <CurrentPage />
                    )
                  }
                />

                <Route path="trends" element={<Trends />} />
                <Route path="trendsmenu" element={<TrendsSetting />} />
                <Route path="reviewalarms" element={<ReviewAlarms />} />
                <Route path="standbyscreen" element={<StandbyScreen />} />

                <Route path="disclaimer" element={<Disclaimer />} />

                {state.popuppages.map((popuppage) => (
                  <Route
                    key={popuppage.name1}
                    path={popuppage.name1}
                    element={<PopUps popuppage={popuppage} />}
                  />
                ))}

                <Route path="settings" element={<SettingLayout />}>
                  <Route index element={<SmartKeyBox />} />
                  {state.settingPages.map((setting) => (
                    <Route
                      key={setting.name1}
                      path={setting.name1}
                      element={<Setting setting={setting} />}
                    />
                  ))}
                </Route>
              </Route>

              <Route path="" element={<ScreenLayout />}>
                <Route path="powerontest" element={<PowerOn />} />
                <Route path="landscape" element={<LandscapePage />} />
              </Route>
            </Routes>
            <Buttons></Buttons>
          </AppBox>
        </AppBg>
      </BrowserRouter>
    </>
  );
}

export default App;
